module.exports = __webpack_public_path__ + "img/Sead Kolasinac.2ecbd1f1.png";